import { MapService } from '../map.service';
import { Sld } from './sld';
import { StacAsset } from './stacasset';
import { StacLink } from './staclink';

export class StacItem {
    public href: string|undefined;       // The STAC item URL, e.g. s3://ws-eric/processing-results/xxx/item.json
    public id: string;
    public geometry: Object|undefined;
    public bbox: [number]|undefined;
    public collection: string|undefined; // The STAC collection identifier
    public properties: any;
    public links: StacLink[] = [];
    public assets: StacAsset[] = [];

    // WMS server URL for the asset, e.g.
    // https://geoserver.dev.f-tep.com/geoserver-cloud/463010c0-0723-11f1-991f-6a8672cac7fb_myfile_tif_GdalWarp_1770798406066147921_myfile.tif/wms
    wmsUrl: string|undefined;
    // WMS layer name, e.g.
    // 463010c0-0723-11f1-991f-6a8672cac7fb_myfile_tif_GdalWarp_1770798406066147921_myfile.tif:myfile.tif
    wmsLayerName: string|undefined; 
    // The Openlayers map layer object (when the layer is visible)
    wmsMapLayer: any|undefined;
    // SLD definition
    sld: Sld|undefined;
    defaultSld: Sld|undefined;
    // opacity
    wmsopacity: number|undefined;

    constructor(id:string) {
        this.id = id;
    }

    static parse(item:any, s3data:any, s3bucket:string|undefined, mapService:MapService|undefined): StacItem|null {
        if ('id' in item) {
            let stacItem = new StacItem(item.id);
            stacItem.geometry = item.geometry;
            stacItem.bbox = item.bbox;
            stacItem.collection = item.collection;
            stacItem.properties = item.properties;
            
            // Assets. Combine STAC information with S3 file level data
            if (item.assets) {
                for (let key of Object.keys(item.assets)) {
                    let asset = StacAsset.parse(key, item.collection, item.assets[key], s3data, s3bucket);
                    if (asset) {
                        asset.bbox = item.bbox;
                        stacItem.assets.push(asset);
                    }
                }
            }

            // Manually process links to filter the resulting set
            // Assign WMS links to assets if possible
            if (item.links) {
                for (let l of item.links) {
                    let link = StacLink.parse(l);
                    if (link == null) {
                        continue;
                    }
                    if (link.href.startsWith('https://data-access')) {
                        // Ignore EOEPCA data-access links
                        continue;
                    }
                    if (link.rel == 'self') {
                        // The link that is used when the item is used as job input
                        if (stacItem.href?.startsWith('s3://'+s3bucket)) {
                            // Use the user S3 bucket href whenever it is available
                            continue;
                        }
                        stacItem.href = link.href;
                    } else if (l.rel == 'http://www.opengis.net/def/serviceType/ogc/wms' && mapService) {
                        const url = new URL(l.href);
                        let wmsUrl = url.origin + url.pathname;
                        let wmsLayerName = undefined;
                        let wmsMapLayer = undefined;
                        const params = url.searchParams;
                        if (params.has('eoid') && params.get('eoid') != null) { 
                            wmsLayerName = params.get('eoid')!;
                        } else if (params.has('layers') && params.get('layers') != null) {
                            wmsLayerName = params.get('layers')!;
                        }
                        wmsMapLayer = mapService.getWMSLayer(stacItem);
                        let wmsAssignedToAsset = false;
                        let re = /[^a-zA-Z0-9_.]/g;
                        if (stacItem.assets) {
                            for (let asset of stacItem.assets) {
                                if (asset.href) {
                                    let basename = new URL(asset.href).pathname.split('/').pop();
                                    basename = basename?.replace(re,'_');
                                    //console.log(basename);
                                    //console.log(wmsLayerName);
                                    if (basename && (wmsLayerName?.endsWith(basename) || wmsLayerName?.endsWith(basename+'.tif'))) {
                                        asset.wmsUrl = wmsUrl;
                                        asset.wmsLayerName = wmsLayerName;
                                        asset.wmsMapLayer = mapService.getWMSLayer(asset);
                                        wmsAssignedToAsset = true;
                                        break;
                                    }
                                }
                            }
                        }
                        if (!wmsAssignedToAsset) {
                            stacItem.wmsUrl = wmsUrl;
                            stacItem.wmsLayerName = wmsLayerName;
                            stacItem.wmsMapLayer = mapService.getWMSLayer(stacItem);
                        }
                    }
                    stacItem.links.push(l);
                }
            }

            return stacItem;
        }
        return null;
    }
}
